import { render, staticRenderFns } from "./BirthDate.vue?vue&type=template&id=7a22c71b&scoped=true"
import script from "./BirthDate.vue?vue&type=script&lang=js"
export * from "./BirthDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22c71b",
  null
  
)

export default component.exports